var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ticket-form",
    {
      attrs: { step: _vm.currentStep, valid: _vm.isValid },
      on: {
        "update:step": function($event) {
          _vm.currentStep = $event
        }
      }
    },
    [
      _c(
        "v-stepper-step",
        {
          class: {
            "current-step": _vm.currentStep === 1,
            "next-step": _vm.highestStepReached < 1,
            "previous-step": _vm.highestStepReached > 1
          },
          attrs: {
            "edit-icon": "mdi-ticket-confirmation-outline",
            "complete-icon": "mdi-ticket-confirmation-outline",
            complete: "",
            editable: _vm.highestStepReached >= 1,
            step: "1"
          }
        },
        [
          _vm._v(" Información general "),
          _c("small", [
            _vm._v(
              " En esta sección podrás especificar los detalles de tu requerimiento. "
            )
          ])
        ]
      ),
      _c(
        "v-stepper-content",
        { attrs: { step: "1" } },
        [
          _vm.isMounted
            ? _c("management-managed-services-general-information", {
                attrs: { "values-of-form": _vm.formValues },
                on: { nextStep: _vm.nextStep }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-stepper-step",
        {
          class: {
            "current-step": _vm.currentStep === 2,
            "next-step": _vm.highestStepReached < 2,
            "previous-step": _vm.highestStepReached > 2
          },
          attrs: {
            "edit-icon": "mdi-check-all",
            "complete-icon": "mdi-check-all",
            complete: "",
            step: "2"
          }
        },
        [
          _vm._v(" Resumen del ticket de Gestión y Servicios Administrados "),
          _c("small", [
            _vm._v(" Resumen de toda la información suministrada hasta ahora ")
          ])
        ]
      ),
      _c(
        "v-stepper-content",
        { attrs: { step: "2" } },
        [
          _c("management-managed-services-ticket-confirmation", {
            ref: "Step2",
            attrs: { generalInformation: _vm.formValues.generalInformation },
            on: {
              nextStep: _vm.nextStep,
              previousStep: _vm.previousStep,
              reset: function($event) {
                return _vm.$router.push({ name: "tickets" })
              },
              sendRequirementTicket: _vm.sendRequirementTicket
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }